import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ASaleItem from '@react/components/a-sale-item';
import Copyright from '@react/containers/copyright';
const createSaleItemElements = (saleItemList) => {
    if (saleItemList.length === 0) {
        return React.createElement("div", null);
    }
    return saleItemList.map((saleItem) => {
        return React.createElement(ASaleItem, { saleItem: saleItem, key: saleItem.name });
    });
};
const Index = () => {
    const [saleItemList, setSaleItemList] = useState([]);
    // 商品一覧データの取得
    useEffect(() => {
        axios.get(`${_DATA_PATH}?${new Date().getTime()}`).then(res => {
            // 一覧データのセット
            setSaleItemList(res.data);
        });
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { className: "card-sale-item-group" }, createSaleItemElements(saleItemList)),
        React.createElement(Copyright, { saleItemList: saleItemList })));
};
export default Index;
